import { render } from "./ExamEventDetailedReport.vue?vue&type=template&id=44738bb7&scoped=true"
import script from "./ExamEventDetailedReport.vue?vue&type=script&lang=js"
export * from "./ExamEventDetailedReport.vue?vue&type=script&lang=js"

import "./ExamEventDetailedReport.vue?vue&type=style&index=0&id=44738bb7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44738bb7"]])

export default __exports__